<script>
  import CompanyAwareMixin from '../base/CompanyAwareMixin.vue'
  import CreateView from '../base/CreateView.vue'
  import FormInput from '../form/form-input.vue'
  import FormLookup from '../form/form-lookup.vue'

  export default {
    components: {
      CreateView,
      FormInput,
      FormLookup,
    },
    mixins: [
      CompanyAwareMixin,
    ],
    data () {
      return {
        store: 'project/create'
      }
    },
  }
</script>
<template>
  <create-view store="project" update-route="ProjectUpdate" v-slot:default="slotProps" @reset="resetted">
    <form-lookup :store="slotProps.store" prop-name="customer" class="col-4">
      <template v-slot:selected-item="slotProps">
        {{slotProps.item.addr1}}
        {{slotProps.item.addr2}}
      </template>
      <template v-slot:item="slotProps">
        {{slotProps.item.addr1}}<br/>
        {{slotProps.item.addr2}}
      </template>
    </form-lookup>
    <form-input :store="slotProps.store" prop-name="name" class="col-3"></form-input>
  </create-view>
</template>

